import { render, staticRenderFns } from "./MarketingMailPlan.vue?vue&type=template&id=45b809c2&scoped=true&"
import script from "./MarketingMailPlan.vue?vue&type=script&lang=js&"
export * from "./MarketingMailPlan.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMailPlan.vue?vue&type=style&index=0&id=45b809c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b809c2",
  null
  
)

export default component.exports